import PropTypes from "prop-types"

export const COMPOSITE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  ticker: PropTypes.string.isRequired,
  mic: PropTypes.string,
  country: PropTypes.string,
  assetClass: PropTypes.oneOf(["equity", "index"]).isRequired,
  description: PropTypes.string.isRequired,
  factorExposure: PropTypes.number.isRequired,
})
